import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Feed from './Feed'
import NewMessage from './NewMessage'

const Activity = () => (
  <Box gap="s40">
    <NewMessage />
    <Feed />
  </Box>
)

export default Activity
